<template>
  <div class="context">
    <div
      class="content"
      style="background-image: url(/67475cb58c6df902b90f9ecd_drip-1.webp)"
    >
      <img
        class="logo"
        src="/674aa988f8c8e65f340015bf_coin-animated.svg"
        alt="PSLY.COM"
      />
      <div class="text">Coming Soon</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  flex-grow: 1;
  align-self: stretch;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: 50% 50%;
  background-size: cover;

  color: #4dfff9;
}
.logo {
  max-width: 16rem;
}
.text {
  max-width: 32rem;
  font-weight: bold;
  font-size: 3rem;
}
</style>
